import { InitOptions, LanguageDetectorModule, Services } from 'i18next';
import { Key, storage } from '@soluto-private/mx-context';

export class MxContextLanguageDetector implements LanguageDetectorModule {
    public type: 'languageDetector';
    public static type = 'languageDetector' as const;

    public init(
        _services: Services,
        _detectorOptions: object,
        _i18nextOptions: InitOptions
    ) {}

    public cacheUserLanguage(lng: string) {
        // called on init and i18next.changeLanguage()
        const currentCachedLanguage = storage.get(Key.Language);
        if (lng !== currentCachedLanguage) {
            storage.set(Key.Language, lng);
        }
    }

    public detect(): string {
        return storage.get(Key.Language) || navigator.language;
    }
}
